import React, { useState } from "react";
import styled from "styled-components";
import { Link, useHistory } from "react-router-dom";
import { TiLocation } from "react-icons/ti";
import { FaLinkedin } from "react-icons/fa";
const StyledContainer = styled.section`
	height: 100vh;
	width: 100vw;
	background-image: url("https://i.imgur.com/9WvzeiR.jpg");
	background-size: cover;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`;

const StyledInput = styled.input`
	padding: 10px 80px;
	text-align: start;
	outline: none;
	border: none;
	border-radius: 100px;
	background-color: #a5a5a56f;
	font-size: 32px;
	color: #ffffff;
	&::placeholder {
		color: #505050;
	}
`;

const StyledButton = styled.span`
	margin-top: 20px;
	width: 100px;
	background-color: #ffffff;
	text-align: center;
	border-radius: 100px;
	padding: 10px 40px;
	&:hover {
		cursor: pointer;
		background-color: #000000;
		color: #ffffff;
	}

	margin-bottom: auto;
`;

const StyledNavBar = styled.div`
	margin-bottom: auto;
	width: 100%;
	display: flex;
	justify-content: space-around;
	align-items: center;
	text-align: right;
	a {
		text-decoration: none;
		color: inherit;
		margin-right: 10px;
	}
	span {
		padding: 10px 25px;
		border-radius: 500px;
	}
	span:hover {
		cursor: pointer;
		background-color: #f0e9e975;
	}
	* {
		margin-right: 20px;
		margin-top: 20px;
	}
`;

const StyledFooter = styled.div`
	color: #000000;
	font-weight: 700;
	font-size: 16px;
	padding: 20px;
	a {
		text-decoration: none;
		margin-right: 10px;
		color: #ffffff;
	}
`;

const Home = () => {
	const [inputValue, setInputValue] = useState();
	let history = useHistory();
	const handleChange = (e) => {
		let string = e.target.value;
		setInputValue(string);
	};

	const handleEvent = (e) => {
		if (e.code === "Enter" || (e.type === "click" && inputValue.length > 3)) {
			history.push(inputValue);
		}
	};

	return (
		<StyledContainer>
			<StyledNavBar>
				<div>
					<a href="https://www.weatherapi.com/" title="Free Weather API">
						<img
							src="https://cdn.weatherapi.com/v4/images/weatherapi_logo.png"
							alt="Weather data by WeatherAPI.com"
						/>
					</a>
				</div>
				<div>
					<span>
						<Link to="/top-cities">Cities</Link>
					</span>
					<TiLocation size={32} />
				</div>
			</StyledNavBar>
			<StyledInput
				placeholder="Location..."
				onChange={handleChange}
				onKeyPress={handleEvent}
			/>
			<StyledButton onClick={handleEvent}>Search</StyledButton>
			<StyledFooter>
				<a href="https://www.linkedin.com/in/stefanopitto/">
					<FaLinkedin size={30} />
				</a>
			</StyledFooter>
		</StyledContainer>
	);
};

export default Home;
